<template>
  <div id="background-image">
    <div id="wrapper" style="position:absolute; left:50%; top:50%; transform: translate(-50%,-50%);">
      <div class="image-table">
        <div class="head">
          <div class="bts">
            <el-upload
              ref="imageUploader"
              :on-change="handleFileChange"
              :before-upload="handleUploadBefore"
              :on-success="handleSuccess"
              :on-error="removeField"
              drag
              :auto-upload="true"
              :action="upload()"
              :data="params"
              class="avatar-uploader"
              :limit="0"
              list-type="picture"
              accept="image/jpeg, image/jpg, image/png"
              :show-file-list="false"
            >
              <el-input
                style="margin-right: 5px;"
                placeholder="请上传图片或拖入图片"
              >
                <i slot="prefix" class="el-icon-search el-input__icon" />
              </el-input>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <div id="footer" style="width:100%;height:60px;left:0;position:absolute;bottom:0;text-align: center;color: #efefef;font-size: 1rem;">
      <p>©2022 www.datuji.com</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSearch',
  data() {
    return {
      params: {
        topK: 20,
        total: 0
      },
      searchData: {
        image: '',
        tableData: [],
        total: 0
      },
      imgFile: ''
    }
  },
  computed: {
    imgUrl() {
      return this.imgFile ? this.imgFile.url : ''
    }
  },
  mounted() {
    document.addEventListener('paste', this.handlectrlvEvent)
  },
  beforeDestroy () {
    document.removeEventListener('paste', this.handlectrlvEvent)
  },
  methods: {
    upload() {
      // return 'http://127.0.0.1:9000/api/search/simpleSearch'
      return 'https://www.datuji.com/api/search/simpleSearch'
    },
    handleSuccess(response, file, fileList) {
      if (response.success && response.data) {
        if (response.total) {
          const data = response.data
          data.forEach(a => {
            a.score = ((1 / (1 + Number(a.score))) * 100).toFixed(0)
            // a.score = (Number(a.score)).toFixed(2)
          })
          this.searchData.tableData = data.sort((a, b) => {
            return b.score - a.score
          })
          this.searchData.total = response.total
        } else {
          this.searchData.tableData = []
          this.searchData.total = 0
        }
      } else {
        this.searchData.tableData = []
        this.searchData.total = 0
      }
      this.searchData.image = this.imgFile
      this.$router.push({
          name:'pcList',
          params:{
            searchData: this.searchData
          }
      })
    },
    handleFileChange(file, fileList) {
      if (fileList[0] && fileList[0].size > 2097152) {
        this.$message.warning('请上传小于2M大小的图片')
        this.$refs.imageUploader.clearFiles()
        return false
      }
      this.imgFile = file
    },
    handleUploadBefore(file) {
      if (file.size > 2097152) {
        this.$message.warning('请上传小于2M大小的图片')
        return false
      }
    },
    removeField() {
      this.$refs.imageUploader.clearFiles()
    },
    handlectrlvEvent(event) {
      console.log('handlectrlvEvent')
      const items = (event.clipboardData || window.clipboardData).items;
      //去除粘贴到div事件
      event.preventDefault();
      event.returnValue=false;
      let file = null;
      if (!items || items.length === 0) {
        this.$message.error("当前不支持本地图片上传");
        return;
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        console.log(items[i].type)
        if (items[i].type.includes('image')) {
          file = items[i].getAsFile();
          break;
        }
      }
      if (!file) {
        console.log('粘贴内容非图片')
        this.$message.error("粘贴内容非图片");
        return;
      } else {
        this.params.topK = 20
        this.params.total = 0
        this.$refs.imageUploader.clearFiles()
        this.$refs.imageUploader.handleStart(file);
        let that = this
        setTimeout(() => {
          this.$refs.imageUploader.submit()
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/base";
  #background-image {
    background: url("../assets/images/pc_background.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }

  #wrapper h1 {
    margin: 1rem 0rem;
  }
  .image-table {
    position: relative;
    top: 40px;
    box-sizing: border-box;
    height: 100%;
    :global(.el-upload-dragger) {
      border: none;
      border-radius: 0;
      box-sizing: border-box;
      width: 540px;
      height: 40px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    :global(.el-upload) {
      border: none;
      display: inherit;
    }
  }
  .head {
    margin: 10px 0;
    @include flex-row-between-center;

    .bts {
      @include flex-row-all-center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue